<template>
    <div
        class="gst-billing-details-form gst-septenary-border gst-rounded-xs pa-4">
        <h5 class="mb-6">
            {{ $t('title') }}
        </h5>
        <div class="row">
            <BaseFormInput
                v-if="billingDetails.firstName"
                :id="billingDetails.firstName"
                v-model="billingDetails.firstName"
                :label="$t('labels.firstName')"
                maxlength="30"
                class="col col-12 col-md-6 pt-0"
                :data-test-id="$testId('input.firstName')"
                disabled
                autocomplete="off" />
            <BaseFormInput
                v-if="billingDetails.lastName"
                :id="billingDetails.lastName"
                v-model="billingDetails.lastName"
                :label="$t('labels.lastName')"
                maxlength="30"
                class="col col-12 col-md-6 pt-0"
                :data-test-id="$testId('input.lastName')"
                disabled
                autocomplete="off" />
        </div>
        <div class="row">
            <BaseFormInput
                v-if="billingDetails.emailAddress"
                :id="billingDetails.emailAddress"
                v-model="billingDetails.emailAddress"
                :label="$t('labels.email')"
                maxlength="255"
                class="col col-12 pt-0"
                :data-test-id="$testId('input.email')"
                disabled
                autocomplete="off" />
        </div>
        <p>{{ $t('supportInformation') }}</p>
    </div>
</template>

<script>
export default {
    name: 'BillingDetailsForm',
    props: {
        billingDetails: {
            type: Object,
            default: null,
        }
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBookingCheckout._components.billingDetailsForm',
    },
}
</script>

<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-billing-details-form {
    h4 {
        color: theme-color('quaternary');
        font-weight: font-weight('large');
    }

    ::v-deep .gst-base-form-input .gst-base-form-input__input {
        background-color: theme-color('senary');
        color: theme-color('tertiary');
        font-size: font-size('l');
        font-weight: font-weight('regular');
    }

    ::v-deep .gst-base-form-input .gst-base-form-input__input:hover {
        border: 1px solid theme-color('septenary');
    }

    p {
        margin-bottom: 0;
    }
}
</style>